/* global ma */

import { getHeaders } from "./security";
const startPay = (prepayId, orderInfo, sign, callback) => {
  ma.callNativeAPI(
    "startPay",
    {
      prepayId: prepayId,
      orderInfo: orderInfo,
      sign: sign,
      signType: "SHA256",
    },
    callback
  );
};

export const initialFunctions = () => {
  return new Promise((resolve, reject) => {
    let kpay_token = "";
    ma.callNativeAPI(
      "gethwssostring",
      { merchantAppId: "kpc27a4a5351fa469783e9138061588a" }, // development
      // { merchantAppId: "kpe89bc4b38ff643caa6c0b2d6843280" }, // production
      async (res) => {
        kpay_token = res.xm_string_callback_key;

        // After obtaining kpay_token, make the fetch request
        const headers = await getHeaders('request_userid');
        const url = "https://apiv2.shwenarsin.com/api/app/miniapp/request_userid";
        const options = {
          method: "POST",
          headers: headers,
          body: JSON.stringify({
            kpay_token: kpay_token,
            // version_code: 1001, // this is for production
          }),
        };

        fetch(url, options)
          .then((response) => response.json())
          .then((data) => {
            localStorage.setItem("infobox", JSON.stringify(data.infobox));
            localStorage.setItem("show_tcpage", JSON.stringify(data.show_tcpage));
            localStorage.setItem("infobox_text", JSON.stringify(data.infobox_text));
            localStorage.setItem("tcpage_img", data.tcpage_img);
            // Handle the response data, and set user_id in storage
            localStorage.setItem("userId", JSON.stringify(data.user_id));
            
            resolve(data); // Resolve the promise with the data
          })
          .catch((error) => {
            console.error("Error:", error);
            reject(error); // Reject the promise if there's an error
          });
      }
    );
  });
};


export const setTitle = () => {
  ma.callNativeApi("setNavigationBarTitle", { title: "Shwe Nar Sin" }, (result) => {
    console.log('title', result);
  });
};
export default startPay;
